import Api from "./api.service";
import { decamelizeKeys } from "humps";

class Templates {
  static all(tenantSlug, params) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/templates`, { params: decamelizeKeys(params) });
  }

  static create(tenantSlug, data) {
    const { name } = data.template;
    const payload = {
      data: {
        type: "templates",
        attributes: { name },
        relationships: {
          tenant: {
            data: {
              id: tenantSlug,
              type: "tenants"
            }
          }
        }
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/templates`, payload);
  }

  static get(id, tenantSlug, params) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/templates/${id}`, { params: decamelizeKeys(params) });
  }

  static update(id, tenantSlug, data) {
    const { name } = data.template;
    const payload = {
      data: {
        id,
        type: "templates",
        attributes: { name }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/templates/${id}`, payload);
  }

  static removeFeatureLink(tenantSlug, templateId, id) {
    return Api.delete(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_features/${id}`);
  }

  static updateFeatureLink(tenantSlug, templateId, data) {
    const { id, visible, value } = data;
    const payload = {
      data: {
        id,
        type: "templates_features",
        attributes: {
          visible,
          value
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_features/${id}`, payload);
  }

  static createFeatureLink(tenantSlug, templateId, data) {
    const { value, visible, featureSlug } = data;
    const payload = {
      data: {
        type: "templates_features",
        attributes: {
          value,
          visible
        },
        relationships: {
          template: {
            data: {
              id: templateId,
              type: "templates"
            }
          },
          feature: {
            data: {
              id: featureSlug,
              type: "product_metadata_types"
            }
          }
        }
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_features`, payload);
  }

  static removeBundleLink(tenantSlug, templateId, id) {
    return Api.delete(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_bundles/${id}`);
  }

  static updateBundleLink(tenantSlug, templateId, data) {
    const { id, visible, tiered, size, term } = data;
    const payload = {
      data: {
        id,
        type: "templates_bundles",
        attributes: { visible, tiered, size, term }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_bundles/${id}`, payload);
  }

  static createBundleLink(tenantSlug, templateId, data) {
    const { size, term, visible, bundleSlug, tiered } = data;
    const payload = {
      data: {
        type: "templates_bundles",
        attributes: {
          size,
          term,
          visible,
          tiered
        },
        relationships: {
          template: {
            data: {
              id: templateId,
              type: "templates"
            }
          },
          bundle: {
            data: {
              id: bundleSlug,
              type: "bundles"
            }
          }
        }
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_bundles`, payload);
  }

  static removeLicenseBundleLink(tenantSlug, templateId, id) {
    return Api.delete(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_license_bundles/${id}`);
  }

  static updateLicenseBundleLink(tenantSlug, templateId, data) {
    const { id, visible, tiered, size, term } = data;
    const payload = {
      data: {
        id,
        type: "templates_license_bundles",
        attributes: { visible, tiered, size, term }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_license_bundles/${id}`, payload);
  }

  static createLicenseBundleLink(tenantSlug, templateId, data) {
    const { size, term, visible, bundleSlug, tiered } = data;
    const payload = {
      data: {
        type: "templates_license_bundles",
        attributes: {
          size,
          term,
          visible,
          tiered
        },
        relationships: {
          template: {
            data: {
              id: templateId,
              type: "templates"
            }
          },
          license_bundle: {
            data: {
              id: bundleSlug,
              type: "license_bundles"
            }
          }
        }
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/templates/${templateId}/templates_license_bundles`, payload);
  }
}

const TemplatesService = Object.freeze(Templates);
export default TemplatesService;
